import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { CardPreview } from './components/CardPreview';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { UseMoments } from './components/UseMoments';
import { Bonuses } from './components/Bonuses';
import { SocialProof } from './components/SocialProof';
import { OfferStack } from './components/OfferStack';
import { AfterPurchase } from './components/AfterPurchase';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-night font-sans text-parchment" data-id="element-0" data-mp="23utby4e102bb">
      <noscript data-id="element-1" data-mp="3ikh5c1uvgeva">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3iiwg8rrbto4t" />
      </noscript>
      <Hero data-id="element-3" data-mp="3rd1all5o5hp3" />
      <main data-id="element-4" data-mp="3recctgjguhe3">
        <CardPreview data-id="element-5" data-mp="5yjetptzbev" />
        <PainPoints data-id="element-6" data-mp="6hq1ea16ddl" />
        <SolutionSection data-id="element-7" data-mp="4wylxj0jajy" />
        <HowItWorks data-id="element-8" data-mp="56lhc8rh1lf" />
        <UseMoments data-id="element-9" data-mp="2zl39tfhhuw2o" />
        <Bonuses data-id="element-10" data-mp="2zllen0i82im7" />
        <SocialProof data-id="element-11" data-mp="2zm4zaoz9bl3x" />
        <OfferStack data-id="element-12" data-mp="2zmo5x9jgin2n" />
        <AfterPurchase data-id="element-13" data-mp="2zng1ikd20ksx" />
        <Guarantee data-id="element-14" data-mp="33mf0loc3tncg" />
        <Faq data-id="element-15" data-mp="33lx0uhq8gqzs" />
        <FinalCta data-id="element-16" data-mp="33nggc642ey0i" />
      </main>
      <Footer data-id="element-17" data-mp="33ork45xig5rm" />
      <StickyCta data-id="element-18" data-mp="38lrq6gud18iq" />
    </div>;
}